import { Controller } from "@hotwired/stimulus"

// A single "Import" button for a file-layout version JSON envelope: clicking the
// button opens the hidden file picker, and choosing a file submits the wrapping
// form straight away — so importing is one gesture, not a pick-then-submit pair.
// The server validates the envelope and lands a new draft version.
export default class extends Controller {
  static targets = ["input"]

  open() {
    this.inputTarget.click()
  }

  submit() {
    if (this.inputTarget.files.length) this.element.requestSubmit()
  }
}
